import React from 'react'
import { Modal as RNModal, GestureResponderEvent } from 'react-native'
import { useTranslation } from 'react-i18next'

import Title from '@hedgit/lib/components/typography/title'

import {
  CenteredView,
  ModalView,
  ButtonContainer,
  ButtonsContainer,
  Button,
  TitleContent
} from './styled'

export interface ModalProps {
  visible?: boolean;
  onPress?: (event: GestureResponderEvent) => void;
  onCloseModal?: () => void;
}
const DenySubscriptionModal = ({ onPress, visible, onCloseModal }: ModalProps) => {
  const { t } = useTranslation()

  return (
    <RNModal
      animationType="fade"
      visible={visible}
      presentationStyle="overFullScreen"
      statusBarTranslucent={false}
      transparent
      onRequestClose={onCloseModal}
    >
      <CenteredView testID="deny-modal">
        <ModalView>
          <TitleContent>
            <Title>
              {t('Components.modal.denyModal.text')}
            </Title>
          </TitleContent>
          <ButtonsContainer>
            <ButtonContainer>
              <Button testID="deny-modal-button-cancel" onPress={onPress} variant="secondary">
                {t('Components.button.close')}
              </Button>
            </ButtonContainer>
          </ButtonsContainer>
        </ModalView>
      </CenteredView>
    </RNModal>
  )
}
export default DenySubscriptionModal
